import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Kai Faust
 * id 591A45AB-511C-4791-957C-303186C666AA
 * name format-annotation-plus
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-annotation-plus.svg
 * tags
 * - Text / Content / Format 
 */
export const FormatAnnotationPlusIcon = createSvgIcon(<><path d="M8.5,7H10.5L16,21H13.6L12.5,18H6.3L5.2,21H3L8.5,7M7.1,16H11.9L9.5,9.7L7.1,16M22,5V7H19V10H17V7H14V5H17V2H19V5H22Z" /></>, 'FormatAnnotationPlusIcon');
export default FormatAnnotationPlusIcon